window.bbs = window.bbs || {};

bbs.geomodal = (function () {
  "use strict";

  function init(json) {
    const geomodal = document.querySelector("[data-geomodal]");

    if (geomodal === null) return;

    const now = new Date()

    const storageItem = window.localStorage.getItem("bbsGeoModalOpen");

    if (geomodal.dataset.geomodelEdit === "false") {
      if (storageItem) {
        const jsonStorageItem = JSON.parse(storageItem);
        if (now.getTime() < jsonStorageItem.expiry) {
          return;
        }
      }
    }

    let shop = {
      domain: "rio-de-sol.myshopify.com",
      titleText: "Welcome",
      contentText: "It seems you're in [country].",
      buttonText: "Go to the international store",
      dismissText: "No, thanks",
    };

    const shops = {
      PT: {
        domain: "rio-de-sol-pt.myshopify.com",
        titleText: "Bem-vindo",
        contentText: "Parece que você está em Portugal.",
        buttonText: "Vá à loja online de Portugal",
        dismissText: "Não, obrigado",
      },
      BR: {
        domain: "rio-de-sol-br.myshopify.com",
        titleText: "Bem-vindo",
        contentText: "Parece que você está no Brasil.",
        buttonText: "Vá à loja online do Brasil",
        dismissText: "Não, obrigado",
      },
      ES: {
        domain: "rio-de-sol-es.myshopify.com",
        titleText: "Bienvindo",
        contentText: "Parece que estás en España.",
        buttonText: "Ve a la tienda en España",
        dismissText: "No, gracias",
      },
      FR: {
        domain: "rio-de-sol-fr.myshopify.com",
        titleText: "Bienvenue",
        contentText: "Il semble que vous êtes en France.",
        buttonText: "Accédez à la boutique en France",
        dismissText: "Non, merci",
      },
      IT: {
        domain: "rio-de-sol-it.myshopify.com",
        titleText: "Benvenuto",
        contentText: "Sembra che tu sia in Italia.",
        buttonText: "Vai al negozio in Italia",
        dismissText: "No, grazie",
      },
      PL: {
        domain: "rio-de-sol-pl.myshopify.com",
        titleText: "Witaj",
        contentText: "Zdaje się, że jesteś w Polska.",
        buttonText: "Przejdź do sklepu w Polska",
        dismissText: "Nie, dziękuję",
      },
      DE: {
        domain: "rio-de-sol-de.myshopify.com",
        titleText: "Willkommen",
        contentText: "Es scheint, Sie sind in Deutschland.",
        buttonText: "Besuchen Sie den Deutschland Shop",
        dismissText: "Nein, Danke",
      },
      AU: {
        domain: "rio-de-sol-au.myshopify.com",
        titleText: "Welcome",
        contentText: "It seems you're in Australia.",
        buttonText: "Go to the Australian Store",
        dismissText: "No, thanks",
      }
      // NL: {
      //   domain: "rio-de-sol-nl.myshopify.com",
      //   titleText: "Welkom",
      //   contentText: "Het lijkt erop dat je in Nederland bent.",
      //   buttonText: "Ga naar de Nederland winkel",
      //   dismissText: "Nee, dank je",
      // },
    };

    if (typeof shops[json.country_code] !== "undefined") {
      for (const [key, value] of Object.entries(shops[json.country_code])) {
        if (value) {
          shop[key] = value;
        }
      }
    }

    // verify shop is the same
    if (geomodal.dataset.geomodalPermanentDomain === shop.domain) {
      if (geomodal.dataset.geomodelEdit === "false") {
        return;
      }
    }

    // replace placeholder
    shop.contentText = shop.contentText.replace("[country]", json.country);
    shop.buttonText = shop.buttonText.replace("[country]", json.country);

    // location
    const location = "https://" + shop.domain + geomodal.dataset.geomodelPath;

    // title
    const title = geomodal.querySelector("[data-geomodal-title]");

    title.innerHTML = shop.titleText;

    // content
    const content = geomodal.querySelector("[data-geomodal-content]");

    content.innerHTML = shop.contentText;

    // flag
    const flag = geomodal.querySelector("[data-geomodal-flag]");

    flag.src = flag.dataset.src.replace(
      "[code]",
      json.country_code.toLowerCase()
    );

    // button
    const button = geomodal.querySelector("[data-geomodal-button]");

    button.innerHTML = shop.buttonText;

    button.addEventListener("click", function (event) {
      event.preventDefault();
      window.location = location;
    });

    // dismiss
    const dismiss = geomodal.querySelector("[data-geomodal-dismiss]");

    dismiss.innerHTML = shop.dismissText;

    const delay = parseInt(geomodal.dataset.geomodalDelay) * 1000;

    openModal(geomodal, delay);

    window.localStorage.setItem("bbsGeoModalOpen", JSON.stringify({ expiry: now.getTime() + 604800000 })); // 7 days

    const close = geomodal.querySelectorAll("[data-geomodal-close]");

    for (let i = 0, l = close.length; i < l; i++) {
      close[i].addEventListener("click", function (event) {
        event.preventDefault();
        closeModal(geomodal);
      });
    }
  }

  function openModal(element, delay) {
    setTimeout(function () {
      element.classList.add("active");
      setTimeout(function () {
        element.classList.add("opacity");
      }, 50);
    }, delay);
  }

  function closeModal(element) {
    element.classList.remove("opacity");
    setTimeout(function () {
      element.classList.remove("active");
    }, 400);
  }

  return {
    init: init,
  };
})();

document.addEventListener("BBSGeoipLoaded", function (event) {
  bbs.geomodal.init(event.detail);
});
